module.exports = __webpack_public_path__ + "img/snippin-light.f5d4df0a.svg";